module.exports = {"id":"dp2_1l1q3","text":"Interacting Through Digital Technologies","instructions":"Which feature is commonly found in digital communication tools?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l1q3-a1","text":"Sending and receiving messages","score":1.8},{"id":"dp2_1l1q3-a2","text":"Automatic physical movement","score":0},{"id":"dp2_1l1q3-a3","text":"Biological decision making","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l1q3.json
// module id = 988
// module chunks = 41